import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage/storage.service';
import { UserService } from '../services/user/user.service';

@Injectable({
  providedIn: 'root'
})
export class DevGuard {
  private storageService = inject(StorageService);
  private userService = inject(UserService);
  private router = inject(Router);

  canActivate(): boolean {
    if (this.userService.isDevUser(this.storageService.getUser())) {
      return true;
    }
    this.router.navigate(['/front/dashboard']);
    return false;
  }
}
